




import {
  Component,
  Prop,
  Ref,
  Vue,
} from 'vue-property-decorator';
import { initializeGoogleMaps, MAP_ICONS } from '@/utils/google-maps-utils';
import MapContainer from '@/components/common/MapContainer.vue';
import { LocationStatus } from '@/enums';

@Component({
  components: { MapContainer },
})
export default class GoogleMap extends Vue {
  @Prop({ required: true }) private readonly latitude!: number;

  @Prop({ required: true }) private readonly longitude!: number;

  @Prop({ required: true }) private readonly locationState!: number;

  @Ref('mapContainerRef') private readonly mapContainerRef!: Vue;

  private map: google.maps.Map | null = null;

  private marker: google.maps.Marker | null = null;

  mounted(): void {
    this.initMap();
  }

  async initMap(): Promise<void> {
    const google = await initializeGoogleMaps();
    // wait for popup to be loaded
    await new Promise((resolve) => setTimeout(resolve, 500));
    const position: google.maps.LatLng = new window.google.maps.LatLng(this.latitude, this.longitude);

    const mapElement = this.mapContainerRef.$refs.mapRef as HTMLElement;

    this.map = new google.maps.Map(mapElement, {
      zoom: 14,
      center: position,
    });

    this.marker = new google.maps.Marker({
      position,
      map: this.map,
      icon: this.locationState === LocationStatus.Open ? MAP_ICONS.mapIconPink : MAP_ICONS.mapIconBlack,
    });
  }
}
